export default __webpack_public_path__ + "static/media/DH_printing_rules_inches.3302ce1a.pdf";